import { createContext } from "react";

const prospectContext = createContext();

export default prospectContext;
